import PropTypes from 'prop-types';

function IconExperts({
  fill = 'var(--primaryColor)',
  backgroundFill = 'var(--secondaryColor)',
}) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7998 9.1439V4.7999H17.3998V9.5999H11.7998V9.1439Z"
        fill={backgroundFill}
      />
      <path
        d="M9.002 4.19605C9.222 4.19605 9.4 4.01805 9.4 3.79605V2.80005C9.4 2.58005 9.222 2.40005 9.002 2.40005C8.782 2.40005 8.604 2.57805 8.604 2.80005V3.79805C8.604 4.01605 8.782 4.19605 9.002 4.19605Z"
        fill={fill}
      />
      <path
        d="M5.05998 5.21192C5.13798 5.31992 5.25998 5.37592 5.38198 5.37592C5.46398 5.37592 5.54398 5.35192 5.61598 5.29992C5.79398 5.16992 5.83198 4.91992 5.70398 4.74192L5.11998 3.93392C4.99198 3.75592 4.74198 3.71592 4.56398 3.84592C4.38598 3.97592 4.34798 4.22592 4.47598 4.40392L5.05998 5.21192Z"
        fill={fill}
      />
      <path
        d="M3.26595 7.69005L2.31995 7.38205C2.11195 7.31405 1.88795 7.42805 1.81995 7.63805C1.75195 7.84805 1.86595 8.07205 2.07595 8.14005L3.02195 8.44805C3.06195 8.46205 3.10395 8.46805 3.14395 8.46805C3.31195 8.46805 3.46795 8.36005 3.52195 8.19205C3.58795 7.98405 3.47395 7.75805 3.26595 7.69005Z"
        fill={fill}
      />
      <path
        d="M3.01981 11.5138L2.07381 11.8218C1.86581 11.8898 1.74981 12.1158 1.81781 12.3238C1.87381 12.4918 2.02981 12.5998 2.19781 12.5998C2.23781 12.5998 2.27981 12.5938 2.31981 12.5798L3.26581 12.2718C3.47381 12.2038 3.58981 11.9778 3.52181 11.7698C3.45181 11.5598 3.22781 11.4458 3.01981 11.5138Z"
        fill={fill}
      />
      <path
        d="M10.7998 17.3999H7.1998C6.9798 17.3999 6.7998 17.5799 6.7998 17.7999C6.7998 18.0199 6.9798 18.1999 7.1998 18.1999H10.7998C11.0198 18.1999 11.1998 18.0199 11.1998 17.7999C11.1998 17.5799 11.0198 17.3999 10.7998 17.3999Z"
        fill={fill}
      />
      <path
        d="M10.3997 18.7999H7.59971C7.37971 18.7999 7.19971 18.9799 7.19971 19.1999C7.19971 19.4199 7.37971 19.5999 7.59971 19.5999H10.3997C10.6197 19.5999 10.7997 19.4199 10.7997 19.1999C10.7997 18.9799 10.6197 18.7999 10.3997 18.7999Z"
        fill={fill}
      />
      <path
        d="M18.1999 10.4V3.99996H12.9999V2.79996C12.9999 1.91796 13.7179 1.19996 14.5999 1.19996C15.4819 1.19996 16.1999 1.91796 16.1999 2.79996C16.1999 3.01996 16.3799 3.19996 16.5999 3.19996C16.8199 3.19996 16.9999 3.01996 16.9999 2.79996C16.9999 1.47596 15.9239 0.399963 14.5999 0.399963C13.2759 0.399963 12.1999 1.47596 12.1999 2.79996V3.99996H10.9999V5.65196C10.3959 5.36196 9.7159 5.19996 8.9999 5.19996C6.4599 5.19996 4.3999 7.23596 4.3999 9.72996C4.3999 11.262 4.8379 11.874 5.6919 13.1C5.8899 13.362 6.0859 13.67 6.3059 13.998C6.7659 14.698 6.7659 15.486 6.7659 15.946V15.99V16.406C6.7659 16.624 6.9419 16.8 7.1599 16.8H10.8639C11.0819 16.8 11.2579 16.624 11.2579 16.406V15.99V15.946C11.2579 15.486 11.2579 14.698 11.7179 13.998C11.9379 13.648 12.1559 13.364 12.3319 13.1C13.0319 12.07 13.4499 11.472 13.5679 10.398H18.1999V10.4ZM11.7999 9.14396V4.79996H17.3999V9.59996H11.7999V9.14396ZM11.7179 12.576L11.6639 12.656C11.6019 12.75 11.5339 12.846 11.4619 12.948C11.3339 13.128 11.1899 13.332 11.0439 13.566C10.4579 14.464 10.4579 15.428 10.4579 15.946V15.99V16H7.5659V15.99V15.946C7.5659 15.426 7.5659 14.46 6.9719 13.554L6.8399 13.356C6.6699 13.1 6.5079 12.856 6.3419 12.632L6.3239 12.606C5.5059 11.434 5.1999 10.996 5.1999 9.72996C5.1999 7.67396 6.9039 5.99996 8.9999 5.99996C9.7339 5.99996 10.4179 6.20596 10.9999 6.56196V8.98796V10.4H12.7599C12.6539 11.198 12.3299 11.676 11.7179 12.576Z"
        fill={fill}
      />
      <path
        d="M14.5998 5.99991C14.1578 5.99991 13.7998 6.35791 13.7998 6.79991C13.7998 7.09591 13.9618 7.34991 14.1998 7.48991V7.99991C14.1998 8.21991 14.3798 8.39991 14.5998 8.39991C14.8198 8.39991 14.9998 8.21991 14.9998 7.99991V7.48991C15.2378 7.35191 15.3998 7.09591 15.3998 6.79991C15.3998 6.35791 15.0418 5.99991 14.5998 5.99991Z"
        fill={fill}
      />
    </svg>
  );
}

IconExperts.propTypes = {
  fill: PropTypes.string,
  backgroundFill: PropTypes.string,
};

export default IconExperts;
